<div class="bg-white">
    <section class="hero w-fullscreen">
        <div class="hero-text">
            <img src="assets/images/logo_taxchecker.svg" alt="taxchecker">
            <h2 class="color-blue Font-Inter-Black">{{ 'taxchecker.hero.title' | translate }}</h2>
    
            <p class="color-blue Font-Helvetica-Roman">{{ 'taxchecker.hero.parraf' | translate }}</p>
    
            <button mat-button class="btn-tch" (click)="ngContacto()">
                {{ 'taxchecker.hero.btn' | translate }}
            </button>
        </div>
        <figure class="m-0">
            <img src="assets/images/laptop.png" alt="laptop" class="laptop">
        </figure>
    </section>  
</div>

<div class="bg-contenedor">
    <section class="solucion w-fullscreen">
        <div class="img-content">
            <img src="assets/images/laptop2.png" alt="nosotros">
        </div>
        <div class="text">
            <h2 class="color-blue Font-Inter-Black">{{ 'taxchecker.solution.title' | translate }}</h2>
            <p class="color-blue Font-Helvetica-Roman">{{ 'taxchecker.solution.parraf' | translate }}</p>
    
            <button mat-button class="color-purple Font-Inter-Bold" (click)="ngContacto()">
                {{ 'taxchecker.solution.btn' | translate }}
              <mat-icon>
                arrow_right
              </mat-icon>
            </button>
        </div>
    
    </section>
</div>

<div class="bg-white">
    <section class="section-list w-fullscreen">
        <div class="text">
            <div class="item">
                <h2 class="color-blue Font-Inter-Black">{{ 'taxchecker.list.title' | translate }}</h2>
    
                <div class="item-list">
                    <img src="assets/images/check-taxtech.png" alt="check">
                    <span class="color-blue Font-Helvetica-Roman parraf">{{ 'taxchecker.list.parrafs.first' | translate }}</span>
                
                </div>
                <div class="item-list">
                    <img src="assets/images/check-taxtech.png" alt="check">
                    <span class="color-blue Font-Helvetica-Roman parraf">{{ 'taxchecker.list.parrafs.second' | translate }}</span>
        
                </div>
                <div class="item-list">
                    <img src="assets/images/check-taxtech.png" alt="check">
                    <span class="color-blue Font-Helvetica-Roman parraf">{{ 'taxchecker.list.parrafs.third' | translate }}</span>
             
                </div>
                <div class="item-list">
                    <img src="assets/images/check-taxtech.png" alt="check">
                    <span class="color-blue Font-Helvetica-Roman parraf">{{ 'taxchecker.list.parrafs.fourth' | translate }}</span>
                </div>
            </div>
        </div>
        <figure class="m-0" class="img-content">
            <img src="assets/images/taxchecker-list.png" alt="laptop" class="taxchecker">
        </figure>
    </section>
</div>



<app-contacto></app-contacto>
